import React from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { headerStatusAction } from './../actions';

import Headroom from 'react-headroom';
import ScrollToTop from 'react-scroll-up';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = { headerHeight: 0 };

    this.closeAll = this.closeAll.bind(this);
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
    this.showImprint = this.showImprint.bind(this);
  }

  componentDidMount() {
    this.setHeaderHeight();
    window.addEventListener('resize', this.setHeaderHeight);
  }

  setHeaderHeight() {
    const headerHeight = this.header.clientHeight;

    this.setState({ headerHeight });
  }

  showImprint() {
    const timeOut = 500;

    document.querySelector('.imprint-label .read-more').click();

    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, timeOut);
  }

  closeAll() {
    // We have one Router for each Section, so no section is closed when another
    // Is opened, so we need to close everything by our own...

    if (document.querySelector('.people-full a.read-more')) {
      document.querySelector('.people-full a.read-more').click();
    }

    if (document.querySelector('.press-article-full a.read-more')) {
      document.querySelector('.press-article-full a.read-more').click();
    }

    if (document.querySelector('a.close-video')) {
      document.querySelector('a.close-video').click();
    }

    const openSections = document.querySelectorAll('a.read-more.active');

    if (openSections.length > 0) {
      for (const section of openSections) {
        section.click();
      }
    }
  }

  render() {
    return (
      <Router>
        <Headroom wrapperStyle={this.state.headerHeight} onPin={() => this.props.dispatch(headerStatusAction(true))} onUnpin={() => this.props.dispatch(headerStatusAction(false))}>
          <header className="page-header" ref={ref => { this.header = ref; }}>
            <div className="wrap">
              <ScrollToTop showUnder={-100} style={{}}>
                <Link to="/" onClick={() => this.closeAll()}>
                  <img title="Avanga Filmproduktion" alt="Avanga Filmproduktion Logo" src={`${require('../../public/img/avanga_logo.png')}`} className="logo" />
                </Link>
              </ScrollToTop>
              <div className="logo-container">
                <a href="https://www.facebook.com/AVANGAFilmproduktion" target="_blank">
                  <svg id="facebook" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     viewBox="0 0 350 350" style={{ enableBackground: 'new 0 0 350 350' }} xmlSpace="preserve">
                  <path fill="#FFFFFF" d="M288.9,5H61.4C30.3,5,5,30.3,5,61.4v227.1c0,31.1,25.3,56.4,56.4,56.4h125.3V213.4h-44.4v-51.3
                    h44.4v-37.9c0-43.9,26.8-67.8,66-67.8c18.7,0,34.9,1.4,39.6,2v45.9h-27.2c-21.3,0-25.4,10.1-25.4,25V162h50.8l-6.7,51.3h-44.3V345
                    h49c31.1,0,56.4-25.3,56.4-56.4V61.4C345.3,30.3,320.1,5,288.9,5z"/>
                  </svg>
                </a>
                <Link onClick={() => this.showImprint()} to="/impressum">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     viewBox="0 0 350 350" style={{enableBackground: 'new 0 0 350 350'}} xmlSpace="preserve">
                  <g>
                    <g>
                      <path fill="#FFFFFF" d="M288.6,5H61.4C30.2,5,5,30.4,5,61.6v227.9c0,27.3,19.3,50.1,44.9,55.4c12.5-57.7,63.7-101.1,125.1-101.1
                        S287.6,287.2,300.1,345c25.6-5.3,44.9-28.1,44.9-55.4v-228C345,30.4,319.7,5,288.6,5z M175,208.7c-35.9,0-65-29.2-65-65.2
                        s29.1-65.2,65-65.2s65,29.2,65,65.2S210.9,208.7,175,208.7z"/>
                    </g>
                  </g>
                  </svg>
                </Link>
              </div>
            </div>
          </header>
        </Headroom>
      </Router>
    );
  }
}

export default connect()(Header);


// WEBPACK FOOTER //
// ./src/layout/header.jsx